if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const inquiryVariants = this.form.querySelector(
  '[data-raya-preorder-variants]'
);

if (inquiryVariants) {
  try {
    const preorderIds = JSON.parse(inquiryVariants.textContent);
    const selectedId = String(this.variantIdInput.value);

    if (preorderIds.includes(selectedId)) {
      const productData = this.form.querySelector(
        '[data-raya-inquiry-product]'
      );

      if (!productData) {
        throw new Error('Missing inquiry product details.');
      }

      const product = JSON.parse(productData.textContent);
      const variant = product.variants.find(
        item => String(item.id) === selectedId
      );

      if (!variant) {
        throw new Error('Missing selected variant.');
      }

      const quantityInput = this.form.querySelector('[name="quantity"]');
      const quantity = quantityInput ? Number(quantityInput.value) : 1;

      if (!Number.isSafeInteger(quantity) || quantity < 1) {
        this.handleErrorMessage(
          'Please enter a whole quantity of 1 or more.'
        );
        return;
      }

      const destination = new URL(
        `${window.Shopify?.routes?.root || '/'}pages/artisan-pre-order-inquiry`,
        window.location.origin
      );

      destination.searchParams.set('view', 'artisan-inquiry-test');
      destination.searchParams.set(
        'product',
        product.title +
          (variant.title === 'Default Title' ? '' : ' / ' + variant.title)
      );
      destination.searchParams.set('quantity', String(quantity));
      destination.searchParams.set('product_id', product.id);
      destination.searchParams.set('variant_id', selectedId);

      window.location.assign(destination.href);
      return;
    }
  } catch (error) {
    console.error('Unable to open the artisan inquiry.', error);
    this.handleErrorMessage(
      'The inquiry could not be opened. Please refresh and try again.'
    );
    return;
  }
}

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
const preorderField = this.form.querySelector('[data-raya-preorder]');
const preorderData = this.form.querySelector(
  '[data-raya-preorder-variants]'
);

if (preorderField && preorderData) {
  preorderField.disabled = true;

  try {
    const preorderVariantIds = JSON.parse(preorderData.textContent);
    const selectedVariantId = String(this.variantIdInput.value);

    preorderField.disabled = !preorderVariantIds.includes(
      selectedVariantId
    );
  } catch (error) {
    console.error('Unable to read Artisan Pre-Order status.', error);
  }
}


        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
